import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Store, ShoppingBag, Truck, Users, Settings, Printer } from 'lucide-react';
export function Sidebar() {
  const location = useLocation();
  const navigation = [{
    name: 'Dashboard',
    href: '/',
    icon: LayoutDashboard
  }, {
    name: 'Pop-Up Stores',
    href: '/pop-up-stores',
    icon: Store
  }, {
    name: 'Orders',
    href: '/orders',
    icon: ShoppingBag
  }, {
    name: 'Fulfillment',
    href: '/fulfillment',
    icon: Truck
  }, {
    name: 'Organizations',
    href: '/organizations',
    icon: Users
  }, {
    name: 'Settings',
    href: '/settings',
    icon: Settings
  }];
  const isActive = (path: string) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };
  return <div className="flex h-full w-64 flex-col bg-white border-r border-gray-200" data-id="element-86">
      <div className="flex h-16 items-center px-6 border-b border-gray-200" data-id="element-87">
        <Printer className="h-8 w-8 text-red-600 mr-3" data-id="element-88" />
        <span className="text-lg font-bold text-gray-900" data-id="element-89">PrintAdmin</span>
      </div>
      <nav className="flex-1 space-y-1 px-3 py-4" data-id="element-90">
        {navigation.map(item => {
        const active = isActive(item.href);
        return <Link key={item.name} to={item.href} className={`
                group flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors
                ${active ? 'bg-red-50 text-red-700' : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'}
              `} data-id="element-91">
              <item.icon className={`mr-3 h-5 w-5 flex-shrink-0 ${active ? 'text-red-600' : 'text-gray-400 group-hover:text-gray-500'}`} aria-hidden="true" data-id="element-92" />
              {item.name}
            </Link>;
      })}
      </nav>
      <div className="border-t border-gray-200 p-4" data-id="element-93">
        <div className="flex items-center" data-id="element-94">
          <div className="h-8 w-8 rounded-full bg-red-100 flex items-center justify-center text-red-600 font-bold text-xs" data-id="element-95">
            JD
          </div>
          <div className="ml-3" data-id="element-96">
            <p className="text-sm font-medium text-gray-700" data-id="element-97">John Doe</p>
            <p className="text-xs text-gray-500" data-id="element-98">Admin</p>
          </div>
        </div>
      </div>
    </div>;
}